module.exports = __webpack_public_path__ + "static/media/plus.e5f57f20.svg";